
import React, { useState } from "react";
import RequestCycleCountList from "./RequestCycleCountList";
import RequestCycleCount from "./RequestCycleCount";

export default function RequestCycleCountManagement() {
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null);

    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

    return (
        <div className="card shadow-lg main-card">

            {/* HEADER */}
            <div className="card-header bg-secondary text-white">
                <h6 className="mb-0 fw-semibold">
                    {!onlyFormVisible
                        ? "Request Cycle Count"
                        : isCreating
                            ? "Create Request"
                            : "View Request"}
                </h6>
            </div>

            {/* BREADCRUMB */}
            {onlyFormVisible && (
                <nav className="px-3 py-2 border-bottom bg-light">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <button
                                className="btn p-0 text-muted"
                                style={{ textDecoration: "none" }}
                                onClick={closeForm}
                            >

                                Request Cycle Count
                            </button>
                        </li>
                        <li className="breadcrumb-item active text-primary">
                            {isCreating ? "Create Request" : "View Request"}
                        </li>
                    </ol>
                </nav>
            )}

            {/* BODY */}
            <div className="card-body">
                {!onlyFormVisible ? (
                    <RequestCycleCountList
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) => setActiveRecord(row)}
                    />
                ) : (
                    <RequestCycleCount
                        initialValues={activeRecord}
                        viewOnly={!!activeRecord}
                        onCancel={closeForm}
                        onSubmit={closeForm}
                    />
                )}
            </div>
        </div>
    );
}
